import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '../../components/Button';
import LOBJForm from '../../components/LearningObject/LOBJForm';
import BreadCrumb from '../../components/Breadcrumb';
import * as actions from '../../redux/actions/actions-learningobject';

class addLobj extends Component {
  constructor(props) {
    super(props);

    if (props.match.params.id !== '0') {
      props.setForm(props.match.params.id);
    } else {
      props.resetForm();
    }

    this.state = {
      LearningModuleId: props.location.state.LearningModuleId
    };
  }


  handleSubmit = (FormData) => {
    // console.log('formData===', { ...FormData,LearningModuleId: this.state.LearningModuleId });
    this.props.saveLOBJ({ ...FormData, LearningModuleId: this.state.LearningModuleId });
  }


  render() {
    return (
      <>
        <div className="container">
          <BreadCrumb currentPage="Learning Object" />
          <div className="col-md-12 py-3 mb-5">
            <div className="card border-secondary">
              <div className="card-header">
                <div className="row">
                  <div className="col-md-10">
                    { this.props.match.params.id !== '0'
                      ? <span className="fa fa-pencil-alt cardTitle"> Edit Learning Object</span>
                      : <span className="fa fa-plus-square cardTitle"> Create New Learning Object</span>}
                  </div>
                  <div className="col-md-2 text-right">
                    <Button
                      className="btn btn-sm btn-secondary"
                      onClick={() => this.props.history.goBack()}
                    >
                      <span className="fa fa-arrow-left" />
                      {' '}
                      Back
                    </Button>
                  </div>
                </div>
              </div>
              <div className="card-body text-secondary">
                {/* <h3>fnkbfgjbfgb</h3> */}
                <LOBJForm
                  onSubmit={this.handleSubmit}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

addLobj.propTypes = {
  formLoading: PropTypes.bool,
  formError: PropTypes.string,
  saveLOBJ: PropTypes.func,
  location: PropTypes.object.isRequired,
  state: PropTypes.object.isRequired,
  LearningModuleId: PropTypes.string.isRequired
};

addLobj.defaultProps = {
  formLoading: null,
  formError: null,
  saveLOBJ: null
};

const mapStateToProps = ({ learningModule }) => ({});


const mapDispatchToProps = (dispatch) => ({
  saveLOBJ: (data) => dispatch(actions.saveLOBJ(data)),
  setForm: (id) => dispatch(actions.editLOBJ(id)),
  resetForm: () => dispatch(actions.resetForm())
});

export default connect(mapStateToProps, mapDispatchToProps)(addLobj);
